import React from 'react';
import PageHeader from 'components/PageHeader';
import PageFooter from 'components/PageFooter';

const PageLayout = ({ title, subtitle, children, noWrapper = false }) => (
  <div className="min-h-screen bg-smdd-gray text-smdd-black flex flex-col">
    <PageHeader />

    {/* Hero Section */}
    <section className="relative py-12 flex flex-col items-center justify-center text-center bg-gradient-to-r from-orange-400 via-orange-500 to-red-500 text-black">
      <div className="max-w-4xl mx-auto px-6 relative z-10">
        <div className="mb-8">
          <h1 className="text-4xl md:text-6xl font-baijamjuree font-extrabold mb-6 text-black tracking-tight uppercase">
            {title}
          </h1>
          <p className="text-lg mb-8 max-w-xl mx-auto text-black font-baijamjuree font-medium leading-tight">
            {subtitle}
          </p>
        </div>
      </div>
    </section>

    {/* Main Content Section - Conditional wrapper for backward compatibility */}
    {noWrapper ? (
      children
    ) : (
      <section className="bg-[#F7F8FA] py-6">
        <div className="max-w-7xl mx-auto px-6 space-y-8">{children}</div>
      </section>
    )}

    <PageFooter />
  </div>
);

export default PageLayout;
